// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"1869":"e93f42d276045ab0a1eb","9154":"c4a30e144cc894b1525b"}[chunkId] + ".css";
};